module.exports = __webpack_public_path__ + "img/2002_L.123900ca.png";